export default {
    cart: [],
    logger: false,
    order: false,
    step: 1,
    cartArrayIndex: 0
}
